export default "__VITE_ASSET__625edef9__"